import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { useSelector } from "react-redux"
import backend from "api/api"
import { toast, ToastContainer } from "react-toastify"
import { Container, Row, Col, Button } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useParams, Link, useHistory } from "react-router-dom"
export default function CategoryEdit() {
  let { id } = useParams()
  let history = useHistory()
  const { Category } = useSelector(state => state?.CategoryReducer)

  // const { activity } = useSelector(state => state?.ActivityReducer)
  const editCategory = Category.find(e => e?._id === id)
  const [editTheCategory, setEditTheCategory] = useState(editCategory)

  const handleTheCategory = async () => {
    const trimmedCategory = editTheCategory?.name.trim()
    try {
      const body = {
        name: trimmedCategory,
      }
      if (!trimmedCategory) {
        toast.error("Category Name is Required")
        return
      }
      const resp = await backend.put(`api/category/${id}`, body)
      toast.success(resp?.data?.message)
      setTimeout(() => history.push("/triptrader/catagory"), 1000)
    } catch (error) {
      toast.error(error.response.data.message || error.message || error)
    }
  }
  const breadcrumbItems = [
    { title: "Dashboard", path: "/triptrader/dashboard" },
    { title: "Categories", path: "/triptrader/catagory" },
    { title: "Category Edit", path: "#" },
  ]
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Category Edit | Trip Trader</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
              <Breadcrumbs breadcrumbItems={breadcrumbItems} />

                <ol className="breadcrumb m-0">
                  <li className="lbreadcrumb-item active"></li>
                </ol>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} sm={12} md={6}>
                <label
                  htmlFor="example-text-input"
                  className=" col-form-label"
                >
                  Category Name
                </label>

                <input
                  className="form-control"
                  type="text"
                  value={editTheCategory.name}
                  onChange={e =>
                    setEditTheCategory({
                      ...editTheCategory,
                      name: e.target.value,
                    })
                  }
                />
              </Col>
            </Row>
          </div>
          <Row>
            <Col xs={4} sm={3} md={1}>
              <Button
                color="success"
                className="btn btn-success waves-effect waves-light"
                onClick={handleTheCategory}
              >
                Save
              </Button>{" "}
              <ToastContainer />
            </Col>
            <Col xs={3} sm={3} md={6}>
              <Link
                to="/triptrader/catagory"
                color="secondary"
                className="btn btn-secondary waves-effect"
              >
                Cancel
              </Link>{" "}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
